import { DynamicProperty, MetaData } from "./dtos";

export class DynamicPropertyGroupModel {
  keys: Array<DynamicProperty> = [];
  label = "";
}

export class DynamicPropertyGroupPeriodModel {
  keys: Array<string> = [];
  label = "";
  metadata: MetaData;
}
